import http from '../../shared/http.js';
import { hideLoading, notifyError, notifySuccess, showLoading } from '../../shared/notify.js';

// The company-wide settings on /konfiguration: the two Liegezeit threshold sets
// and the follow-up deadline.
//
// A plain submit rather than saving per field on change, unlike the theme
// picker: these values are read together - raising one usually means lowering
// another - so somebody mid-edit would otherwise have every intermediate state
// written and the overdue marks on every list moving under them while they
// think.
export function initKonfigurationForm() {
  const form = document.getElementById('konfiguration-form');
  if (!form) return;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    // Names arrive either as `gruppe[status]` for the two threshold sets or as
    // a plain name for a scalar, and the API expects the first nested. Built
    // from the DOM rather than from a list kept here, so a status added to a
    // catalogue - or a second scalar setting - needs no change in this file.
    //
    // This used to pick out `liegezeitTage` alone by name, which quietly
    // dropped the proposal thresholds beside it: the fields rendered, accepted
    // input and were never sent. Matching the shape rather than the name is
    // what stops the next section added to this form going the same way.
    // Every value used to go through Number() unconditionally, which was fine
    // while the form held only thresholds. A checkbox group carries role names:
    // Number('admin') is NaN, which JSON.stringify writes as null, so the form
    // appeared to submit and silently sent garbage with no error anywhere.
    //
    // The field names ending in `Rollen` are the list-valued ones, collected
    // into an array rather than coerced - the name is repeated across the group
    // so the body arrives as one, and an empty group has to send an empty array
    // rather than nothing, or clearing the last role would be unsaveable.
    const daten = {};
    const istListe = (key) => key.endsWith('Rollen');
    // Everything on this form is a number except the refs, and Number() on an
    // ObjectId is NaN - which JSON.stringify writes as null, the exact trap the
    // role names fell into above. Named rather than pattern-matched: the list
    // is short, and a new text field should have to say so here.
    const TEXT_FELDER = ['standardFiliale'];

    form.querySelectorAll('[data-rollen-gruppe]').forEach((gruppe) => {
      daten[gruppe.dataset.rollenGruppe] = [];
    });

    new window.FormData(form).forEach((value, key) => {
      if (istListe(key)) {
        daten[key] = daten[key] || [];
        daten[key].push(value);
        return;
      }

      if (TEXT_FELDER.includes(key)) {
        // Sent as-is, empty string included: the controller reads '' as "no
        // fallback" and stores null.
        daten[key] = value;
        return;
      }

      const zahl = Number(value);
      const treffer = key.match(/^(.+)\[(.+)\]$/);

      if (treffer) {
        const [, gruppe, feld] = treffer;
        daten[gruppe] = daten[gruppe] || {};
        daten[gruppe][feld] = zahl;
        return;
      }

      daten[key] = zahl;
    });

    showLoading('Konfiguration wird gespeichert …');
    try {
      await http.patch('/konfiguration', daten);
      hideLoading();
      notifySuccess('Konfiguration wurde gespeichert.');
    } catch (err) {
      hideLoading();
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
